module.exports = __webpack_public_path__ + "img/68.c8f58f90.png";